// src/context/ProductContext.js

import React, { createContext, useState, useEffect, useCallback } from 'react';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import ProductService from '../components/AGTUps/services/AGTUps-product-services/productService';

export const ProductContext = createContext();

export const ProductProvider = ({ children }) => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  // Verificar autenticación
  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setIsAuthenticated(!!user);
    });

    return () => unsubscribe();
  }, []);

  const refreshProducts = useCallback(async () => {
    // Solo cargar productos si el usuario está autenticado
    if (!isAuthenticated) {
      console.log('[ProductContext] Usuario no autenticado, omitiendo carga de productos');
      setProducts([]);
      setLoading(false);
      setError(null);
      return;
    }

    try {
      setLoading(true);
      setError(null);
      // Limpia la caché para forzar datos frescos:
      ProductService.clearCache();
      const response = await ProductService.getAllProducts();
      if (response?.data?.products) {
        setProducts(response.data.products);
      }
    } catch (err) {
      console.error('[ProductContext] Error cargando productos:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [isAuthenticated]);

  // Cargar productos inicialmente solo si está autenticado
  useEffect(() => {
    if (isAuthenticated) {
      refreshProducts();
    }
  }, [isAuthenticated, refreshProducts]);

  // Función para actualizar la lista después de crear/editar
  const updateProductList = useCallback((newProduct) => {
    setProducts(prevProducts => {
      const exists = prevProducts.some(p => p.id === newProduct.id);
      if (exists) {
        const updated = prevProducts.map(p => 
          p.id === newProduct.id ? newProduct : p
        );
        return updated;
      }
      return [newProduct, ...prevProducts];
    });
  }, []);

  return (
    <ProductContext.Provider value={{ 
      products, 
      refreshProducts, 
      loading, 
      error,
      updateProductList 
    }}>
      {children}
    </ProductContext.Provider>
  );
};